import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateMosaicAction(
    $tenantId: ID!
    $zoneId: ID!
    $actionIdentifier: FlexibleIdentifierInput!
    $updates: MosaicActionUpdates!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          updateAction(identifier: $actionIdentifier, updates: $updates)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.UpdateMosaicActionMutation,
  undefined,
  graphql.schema.UpdateMosaicActionMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
